import React from "react";
import styles from '../styles/inviteInfo.module.scss'
import { useAssetImage } from "@/platforms/utils";
import { useGetRegisterUrl } from "../hooks/useInviteFriends";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

interface inviteInfoProps {
  list?: any[]
}

const InviteInfo: React.FC<inviteInfoProps> = (props) => {
  const { list } = props
  
  const { t } = useTranslation('inviteFriends')
  const inviteBac01 = useAssetImage('img-invite-01')
  const { data: invUrl } = useGetRegisterUrl()
  
  const textToCopy1 = invUrl?.data?.pcDomainUrlShortUrl
  const textToCopy2 = invUrl?.data?.url
  const handleCopy = (text: string) => {
    if(ut.copyBoard(text)){
      Toast.show(t('inviteInfo.copySuccess'))
    }
  }

  return(
    <div className={styles.inviteInfo}>
      <div className={styles.topImg}>
        <img src={inviteBac01} alt="" /> 
      </div>

      <div className={styles.content}>
        <div className={styles.recommend}>
          <div>
            <div className={styles.recommend_title}>{t('inviteInfo.inviteLink')}</div>
            <div className={styles.recommend_content}>
              <div>{textToCopy1}</div>
              <button onClick={()=>handleCopy(textToCopy1)}>{t('inviteInfo.copy')}</button>
            </div>
          </div>
          <div>
            <div className={styles.recommend_title}>{t('inviteInfo.referralCode')}</div>
            <div className={styles.recommend_content}>
              <div>{textToCopy2}</div>
              <button onClick={()=>handleCopy(textToCopy2)}>{t('inviteInfo.copy')}</button>
            </div>
          </div>
        </div>

        {list && list.length > 0 && (
          <div className={styles.lists}>
            {list?.map((v,index)=>{
              return <div key={index} className={styles.list}>
                <div>{v.content}</div>
                <div>{v.title}</div>
              </div>
            })}
          </div>
        )}
      </div>
    </div>  
  )
}

export default InviteInfo